export default {
	terms: "Условия и положения",
	and: "И",
	actions: {
		Submit: "Отправить",
		BackToLogin: "Вернуться к входу",
		Register: "Зарегистрироваться",
		Logout: "Выйти",
		Update: "Обновить",
		Verify: "Zweryfikuj",
		connect: "Подключиться",
		Taptochange: "Нажмите, чтобы изменить"
	},
	rules: {
		isRequired: "Обязательно",
		require: "{0} обязательно",
		valid: "{0} не является действительным {0}",
		cannotContainBlankStrings: "{0} не может содержать пустые строки"
	},
	options: {
		gender: ["Мужчина", "Женщина"]
	}
};
